import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { message: string; statusCode: string; statusText: string }
  ) {
    console.log('This is from the Error Component: ', data);
  }


}
